export default "__VITE_ASSET__c9cc8160__"